import Form from './Form';
export default Form;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/index.js
// module id = 627
// module chunks = 0